import ShiptypeBaseController from '../common/shiptype.base.controller'

class ShiptypeCreateController extends ShiptypeBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams, CommonLayoutService) {
    super(Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams)
    this.Auth = Auth
    this.$state = $state
    this.User = User
    this.CommonLayoutService = CommonLayoutService;
    this.message = 'Shiptype create'
    this.defaultModel = {
      id: '',
      status: true,
      description: '',
      amountFlag: true,
      unitValue: '',
      amount: '',
      coinFlag: false,
      hhtFlag: true,
      batchField: '',
      sortOrder: 1,
      denominationType: null,
      countable: false,
      daysToCount: null,
      selectedFiles:[],
    }
    this.branchId = this.User.getUser().branchId;

    this.model = angular.copy(this.defaultModel)

    this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: this.$translate.instant('common.yes'),
        off: this.$translate.instant('common.no')
      },
      onColor: 'success',
      offColor: 'danger'
    }
    this.denominationTypes = this.CommonLayoutService.denominationTypes();
  }

  reset() {
    this.model = angular.copy(this.defaultModel);
    this.clearErrors();
  }

  submit(evt) {
    this.loading = true
  
    let shiptypeIcon = [];
    if (this.model.selectedFiles && this.model.selectedFiles.length && this.model.selectedFiles[0].hasOwnProperty('base64Data')) {
      this.model.selectedFiles.forEach((d) => {
        shiptypeIcon.push({ base64String: d.base64Data, fileName: `${this.rawId}.png` });
      })
    }

    this.Service.create({
      id: this.model.id,
      status: this.model.status,
      description: this.model.description,
      amountFlag: this.model.amountFlag,
      amount: this.model.amountFlag ? this.model.amount : 0,
      unitValue: this.model.unitValue,
      coinFlag: this.model.coinFlag,
      hhtFlag: this.model.hhtFlag,
      batchField: this.model.batchField,
      sortOrder: this.model.sortOrder,
      denominationType: this.model.denominationType,
      countable: this.model.countable,
      daysToCount: this.model.daysToCount === '' ? null : this.model.daysToCount,
      shiptypeIcon
    }, this.branchId)
      .then((data) => {
        this.loading = false
        this.askCreate()
      })
      .catch((err) => {
        this.loading = false
        err.data.errors.map((e) => {
          this.errorMessage += e.message + '<br/>'
        })
      })
  }
}

export default ShiptypeCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/create/shiptype.create.controller.js